import styles from "./styles/vocal-remover-step.module.scss";
import Image from "next/image";
import { useMobile } from "@/hooks/use-responsive";

interface VocalRemoverStepProps {
  image: string;
  stepNumber: number;
  description: string;
}

const VocalRemoverStep = ({
  image,
  stepNumber,
  description,
}: VocalRemoverStepProps) => {
  const { isMobile } = useMobile();
  return (
    <div className={styles.step}>
      {isMobile ? (
        <div className={styles.img_wrapper}>
          <Image src={image} alt={""} fill={true} />
        </div>
      ) : (
        <Image src={image} alt={""} width={280} height={140} />
      )}
      <div className={styles.step_info}>
        <div className={styles.step_title}>Step {stepNumber}</div>
        <div className={styles.step_description}>{description}</div>
      </div>
    </div>
  );
};

export default VocalRemoverStep;
